import {DecimalPipe} from '@angular/common'
import {Component, input} from '@angular/core'

@Component({
  selector: 'spb-kalp-item',
  templateUrl: './kalp-item.component.html',
  styleUrls: ['./kalp-item.component.scss'],
  imports: [DecimalPipe]
})
export class KalpItemComponent {
  public text = input<string | number | undefined>('')
  public sum = input<boolean>(false)
  public description = input<string>('')
  public format = input<string>('')
  public suffix = input<string>('')
  public textValue = input<boolean>(false)
  public value = input<string | number | undefined>('')
}
